import axios from 'axios';

export const getDealerships = (idannonceur, lieu) =>
  axios(`${process.env.REACT_APP_DEALERSHIP_API_URL}/${lieu}/${idannonceur}`);

export default { getDealerships };
